<template>
<div>
    <b-row>
        <b-col>
            <div class="form-group">               
                <b-button size="sm" variant="primary" @click="voltar"><i class="fas fa-arrow-alt-circle-left"></i> Voltar</b-button>
            </div>
        </b-col>
    </b-row>
    <div class="row">
        <div class="col-md-2">
            <label for class="text-primary label-status">Status</label>
            <select name id class="form-control" v-model="status" @change="changeData">
                <option value="ABERTO">ABERTOS</option>
                <option value="ATRASADOS">ATRASADOS</option>
                <option value="BAIXADO">BAIXADOS</option>
                <option value="CANCELADO">CANCELADOS</option>
                <option value="TODOS">TODOS</option>
            </select>
        </div>
        <div class="col-md-2">
            <div class="form-group">
                <label for>N. Fatura</label>
                <input class="form-control" v-model="fatura" @input="changeData" />
            </div>
        </div>
        <div class="col-md-2">
            <label for class="text-primary label-status">Banco</label>
            <select name id class="form-control" v-model="banco" @change="changeData">
                <option value="0">TODOS</option>
                <option :value="bc.id" v-for="bc in bancos" :key="bc.id">
                    {{ bc.nome }}
                </option>
            </select>
        </div>

        <div class="col-md-2">
            <div class="form-group">
                <label for>De</label>

                <date-picker :disabled="status === 'ABERTO'" v-model="fromDate" @dp-change="onStartChange" :config="datePickerConfig"></date-picker>
            </div>
        </div>

        <div class="col-md-2">
            <div class="form-group">
                <label for>Até</label>
                <date-picker :disabled="status === 'ABERTO'" v-model="toDate" @dp-change="onEndChange" :config="datePickerConfig"></date-picker>
            </div>
        </div>
        <div class="col-md-2 text-center" v-if="isDist === 0">
            <!--<button class="btn btn-larger btn-success btn-search" @click="loadBoletos"><i class="fa fa-search"></i> Buscar</button>-->
            <div class="form-group">
                <label for>Cod. Distribuidor</label>
                <input class="form-control" v-model="distribuidor" @input="changeData" />
            </div>
            
        </div>       
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="col-md-12" v-if="isCD !== 10">
                        <b-button v-if="isDist === 0" variant="primary" size="sm" @click="showDelete" class="mb-2"><i class="fas fa-check-circle"></i> Selecionar</b-button>
                        <b-button v-if="isDist === 0 && markDelete.length > 0" variant="danger" size="sm" class="mb-2" @click="confirmDelete"><i class="fas fa-times-circle"></i> Excluir</b-button>
                        <b-table :items="boletos" :fields="showHeader" :busy="loadingBoletos" :current-page="pageBoleto" :per-page="perPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" stacked="md" show-empty small>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Carregando ..</strong>
                                </div>
                            </template>
                            <template #empty>
                                <h4>Nenhum dado encontrado!</h4>
                            </template>
                            <template #cell(numero_documento)="row">
                                <b-button size="sm" :disabled="row.item.status === 'CANCELADO'" :href="'/boleto/generate/' + row.item.id" target="_blank">{{ row.value }}</b-button>
                            </template>
                            <template #cell(deletar)="row">
                                <b-form-checkbox v-if="row.item.status === 'ABERTO' && isDist === 0" @change="marcarDeletado(row.item.id)"></b-form-checkbox>
                            </template>
                        </b-table>
                        <b-pagination v-model="pageBoleto" :total-rows="totalBoletos" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </div>
                    <div class="col-md-12" v-if="isCD === 10">
                        <div class="card">
                            <div class="card-body">
                                <table class="table table-bordered table-hover table-striped">
                                    <thead>
                                        <tr>
                                            <th>Lote</th>
                                            <th>Situação Lote</th>
                                            <th>Data Emissão</th>
                                            <th>Data Vencimento</th>
                                            <th>Data Limite Devolução</th>
                                            <th>Imprimir</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="boleto in showBoletosAg" :key="boleto.id">
                                            <td>
                                                <a href="#" v-if="boleto.lote" @click="openModal(boleto)">{{ boleto.lote }}</a>
                                                <span v-else>#</span>
                                            </td>
                                            <td>{{ boleto.status }}</td>
                                            <td>
                                                {{ boleto.data_documento ? formatDate(boleto.data_documento) : "" }}
                                            </td>
                                            <td>
                                                {{ boleto.vencimento ? formatDate(boleto.vencimento) : "" }}
                                            </td>
                                            <td>
                                                {{ boleto.data_documento ? faddDate(boleto.vencimento, 12) : "" }}
                                            </td>
                                            <td v-if="boleto.lote == '999999'">
                                                <a :href="'/boleto/generate/' + boleto.id" target="_blank">
                                                    Imprimir
                                                </a>
                                            </td>
                                            <td v-else>
                                                <a :href="(boleto.lote ? '/boleto/lote/' + boleto.lote : '/boleto/generate/'+ boleto.id)" target="_blank">Imprimir todos</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!------------ modal boletos ---------------->
    <b-modal v-model="openedModalBoleto" size="xl" scrollable :title="`Boletos do Lote ${lote}`">
        <b-card>
            <b-row>
                <b-col class="col-md-2">
                    <label for="status">Status</label>
                    <b-input-group size="sm" class="">
                        <b-form-select id="status" v-model="filter" :options="options"></b-form-select>
                        <!--<b-form-input id="filter-input" v-model="filter"></b-form-input> -->
                    </b-input-group>
                </b-col>
                <b-col class="col-md-4">
                    <label for="rev">Distribuidor / Revendedora</label>
                    <b-input-group size="sm" class="">
                        <b-form-input id="rev" v-model="filterRev"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col class="col-md-3">
                    <label for="dataV">Data de Vencimento</label>
                    <b-input-group class="mb-3">
                        <b-form-datepicker id="dataV" placeholder="Nenhuma data selecionada" dropleft calendar-width="200" dark label-help reset-button label-reset-button="Limpar" size="sm" v-model="filterDateVencimento" :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="pt-BR"></b-form-datepicker>
                    </b-input-group>
                </b-col>
                <b-col class="col-md-3">
                    <label for="dataB">Data de Baixa</label>
                    <b-input-group class="mb-3">
                        <b-form-datepicker id="dataB" placeholder="Nenhuma data selecionada" dropleft calendar-width="200" dark label-help reset-button label-reset-button="Limpar" size="sm" v-model="filterDate" :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="pt-BR"></b-form-datepicker>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-table class="mt-2" :items="showBoletosModal" :fields="fields" striped hover stacked="md" show-empty :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                <template #cell(id)="row">
                    <a :href="'/boleto/generate/' + row.item.id" target="_blank">
                        <i class="fas fa-file-pdf"></i>
                    </a>
                </template>
            </b-table>
            <b-pagination v-if="totalRows > 9" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
        </b-card>
        <template #modal-footer>
            <b-button variant="primary" size="sm" class="float-right" @click="fecharModalBoleto">Fechar</b-button>
        </template>
    </b-modal>
</div>
</template>

<script>
export default {
    data() {
        return {
            perfil: null,
            markDelete: [],
            datePickerConfig: {
                format: "DD/MM/YYYY",
                showClose: true,
            },
            toDate: moment(),
            fromDate: moment().subtract(2, "months"),
            fields: [{
                    label: "Status",
                    key: "status",
                },
                {
                    label: "Fatura",
                    key: "numero_documento",
                },

                {
                    label: "Nome",
                    key: "revendedora",
                    formatter: (value, key, obj) => {
                        return value ? value.nome : obj.distribuidor.nome;
                    },
                },

                {
                    label: "PDV",
                    key: "revendedora.pdv.nome",
                },
                {
                    label: "Emissão",
                    key: "data_documento",
                    sortable: true,
                    formatter: (value) => {
                        return value ? moment(value).format("DD/MM/YYYY") : "";
                    },
                },
                {
                    label: "Vencimento",
                    key: "vencimento",
                    sortable: true,
                    formatter: (value) => {
                        return value ? moment(value).format("DD/MM/YYYY") : "";
                    },
                },
                {
                    label: "Valor",
                    key: "valor",
                    sortable: true,
                    formatter: (value) => {
                        return parseFloat(value).toFixed(2).toString().replace('.', ',')
                    },
                },
                {
                    label: "Dt Baixa",
                    key: "data_baixa",
                    sortable: true,
                    formatter: (value) => {
                        return value ? moment(value).format("DD/MM/YYYY") : "";
                    },
                },
                {
                    label: "Boleto",
                    key: "id",
                },

            ],
            selected: null,
            options: [{
                    value: null,
                    text: "Todos",
                },
                {
                    value: "ABERTO",
                    text: "Aberto",
                },
                {
                    value: "BAIXADO",
                    text: "Baixado",
                },
            ],
            totalBoletos: 1,
            pageBoleto: 1,
            loadingBoletos: false,
            totalRows: 1,
            currentPage: 1,
            perPage: 30,
            sortBy: "data_documento",
            sortDesc: true,
            sortDirection: "asc",
            filterOn: [],
            filter: null,
            filterRev: null,
            filterDate: null,
            filterDateVencimento: null,
            status: "TODOS",
            pages: 0,
            currentPage: 1,
            nextPage: "",
            prevPage: "",
            distribuidor: "",
            total: 0,
            boletos: [],
            cd: 0,
            banco: 0,
            bancos: [],
            isDist: parseInt($("#isDistribuidor").val()),
            isCD: parseInt($("#isCentroDistribuicao").val()),
            fatura: "",
            listaBoletos: [],
            boletosLote: [],
            lote: "",
            filtro_status: "",
            filtro_revend: "",
            filtro_pdv: "",
            filtro_baixa: "",
            formatted: "",
            selected: "",
            openedModalBoleto: false,
        };
    },
    methods: {
        voltar() {
            window.location.href = "/distribuidor/boletos";
        },
        confirmDelete() {            
            const vm = this
            this.$swal.fire({
                title: 'Atenção!',
                icon: 'info',
                html: 'Realmente deseja deletar este(s) boleto(s)?  ' +
                    'Esta ação não poderá ser revertida',
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: 'Sim, Continuar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.value) {
                    vm.deletando()
                }
            })
        },

        async deletando() {
            var vm = this;
            for (var i = 0; vm.markDelete.length > i; i++) {
                await vm.deletar(vm.markDelete[i]);
            }
            vm.loadBoletos();
        },

        marcarDeletado(id) {
            let index = this.markDelete.indexOf(id);
            if (index > -1) {
                this.markDelete.splice(index, 1)
            } else {
                this.markDelete.push(id)
            }

        },
        showDelete() {
            this.fields.unshift({
                label: "Selecionar",
                key: "deletar",
            })
        },

        onContext(ctx) {
            this.formatted = ctx.selectedFormatted;
            this.selected = ctx.selectedDMY;
        },
        openModal(obj) {
            this.boletosLote = this.boletos.filter((el) => el.lote === obj.lote);
            this.lote = obj.lote;
            this.openedModalBoleto = true;
        },
        fecharModalBoleto() {
            this.boletosLote = [];
            this.lote = null;
            this.filterDateVencimento = null;
            this.filterDate = null;
            this.filterRev = "";
            this.filter = null;
            this.openedModalBoleto = false;
        },
        aglutinaBoleto() {
            if (this.listaBoletos.length < 2) {
                this.$swal(
                    "INFORME ao menos 3 boletos para aglutinar em um único documento.",
                    "",
                    "error"
                );
            }
            var params = "";
            for (var i = 0; this.listaBoletos.length > i; i++) {
                if (i === 0) {
                    params = "boletos[0]=" + this.listaBoletos[i];
                } else {
                    params = params + "&boletos[" + i + "]=" + this.listaBoletos[i];
                }
            }
            window.open("/boletos?" + params, "_blank");
        },
        selectBoleto(id) {
            var idx = this.listaBoletos.indexOf(id);
            if (idx < 0) {
                this.listaBoletos.push(id);
            } else {
                this.listaBoletos.splice(idx, 1);
            }
        },
        initDates() {
            this.toDate = moment();
            this.fromDate = moment().subtract(1, "months");
        },
        loadBancos() {
            $(".load").show();
            var vm = this;
            axios
                .get("/banco")
                .then(function (response) {
                    vm.bancos = response.data;
                    $(".loadLotes").hide();
                })
                .catch(function (error) {
                    alert("Erro ao Carregar os Bancos");
                    console.log(error);
                    $(".loadLotes").hide();
                });
        },
        loadBoletos() {
            let data = {
                from: this.fromDate.format("DD-MM-YYYY"),
                to: this.toDate.format("DD-MM-YYYY"),
                status: this.status,
                lote: this.lote,
                page: this.currentPage,
                banco: this.banco,
                documento: this.fatura,
                distribuidor: this.distribuidor,
            };
            var vm = this;
            this.loadingBoletos = true;

            axios
                .get("/boleto/list", {
                    params: data,
                })
                .then(function (response) {
                    let data = response.data;
                    vm.boletos = data;
                    // vm.cd = response.data.cd;
                    // console.log(response.data);
                    vm.totalBoletos = data.length;
                    vm.pageBoleto = 1;
                    vm.markDelete = [];
                    vm.loadingBoletos = false;
                    $(".loading").hide();
                })
                .catch(function (error) {
                    alert("Erro ao carregar os boletos.");
                    $(".loading").hide();
                    console.log(error);
                });
        },
        changeData() {
            this.page = 1;
            this.loadBoletos();
        },

        onStartChange(e) {
            var atual = e.date.format("YYYY-MM-DD");
            var antiga = e.oldDate.format("YYYY-MM-DD");
            if (atual !== antiga) {
                this.fromDate = e.date;
                this.loadBoletos();
            }
        },
        onEndChange(e) {
            var atual = e.date.format("YYYY-MM-DD");
            var antiga = e.oldDate ? e.oldDate.format("YYYY-MM-DD") : moment();
            if (atual !== antiga) {
                this.toDate = e.date;
                this.loadBoletos();
            }
        },
        toPage(page) {
            this.currentPage = page > 0 && page <= this.pages ? page : 1;

            this.loadBoletos();
        },
        formatDate(date) {
            if (!date) {
                return "";
            }
            return moment(date).format("DD/MM/Y");
        },
        faddDate(date, qtd) {
            if (!date) {
                return "";
            }
            return moment(date).add(qtd, "days").format("DD/MM/Y");
        },
        async deletar(id) {
            var vm = this;
            await axios
                .post("/adm/boletos/cancela", {
                    boleto_id: id,
                })
                .catch(function (error) {
                    var e = error.response;
                    vm.$swal("Ops", e ? e.data.errors : `${error}`, "error");
                });
        },
    },
    created() {
        //this.initDates();
        this.loadBancos();
        this.loadBoletos();
    },
    computed: {
        showHeader() {
            return this.fields;
        },
        showBoletosModal() {
            var vm = this;
            var data = this.boletosLote;
            if (this.filter) {
                data = data.filter((el) => {
                    return el.status === this.filter;
                });
            }
            if (this.filterRev) {
                data = data.filter((el) => {
                    if (el.revendedora == undefined) {
                        if (el.distribuidor !== undefined) {
                            return (
                                el.distribuidor.nome
                                .toLowerCase()
                                .indexOf(this.filterRev.toLowerCase()) > -1
                            );
                        }
                    } else {
                        return (
                            el.revendedora.nome
                            .toLowerCase()
                            .indexOf(this.filterRev.toLowerCase()) > -1
                        );
                    }
                });
            }
            if (this.filterDate) {
                data = data.filter((el) => {
                    return el.data_baixa === this.filterDate;
                });
            }
            if (this.filterDateVencimento) {
                data = data.filter((el) => {
                    return el.vencimento === this.filterDateVencimento;
                });
            }
            vm.totalRows = vm.boletos.length;
            return data;
        },

        showBoletos() {
            var dataTable = this.boletosLote;
            var vm = this;
            if (vm.filtro_revend) {
                dataTable = dataTable.filter((el) => {
                    if (el.revendedora) {
                        return (
                            el.revendedora.nome
                            .toLowerCase()
                            .indexOf(vm.filtro_revend.toLowerCase()) > -1
                        );
                    }
                });
            }
            if (vm.filtro_status) {
                dataTable = dataTable.filter((el) => {
                    return el.status.indexOf(vm.filtro_status) > -1;
                });
            }
            if (vm.filtro_pdv) {
                dataTable = dataTable.filter((el) => {
                    if (el.revendedora.pdv) {
                        return (
                            el.revendedora.pdv.nome
                            .toLowerCase()
                            .indexOf(vm.filtro_pdv.toLowerCase()) > -1
                        );
                    }
                });
            }
            if (vm.filtro_baixa) {
                dataTable = dataTable.filter((el) => {
                    if (el.data_baixa) {
                        return el.data_baixa.indexOf(vm.filtro_baixa.toLowerCase()) > -1;
                    }
                });
            }
            return dataTable;
        },
        showDataBaixa() {
            var data = [];
            this.boletosLote.map(function (a) {
                if (data.indexOf(a.data_baixa) < 0) {
                    data.push(a.data_baixa);
                }
            });
            return data;
        },
        showBoletosAg() {
            const _boletos = this.boletos;
            var data = [];
            _boletos.map((el) => {
                if (data.length > 0) {
                    const _data = data.find((it) => it.lote === el.lote);
                    if (!_data) {
                        data.push(el);
                    }
                } else {
                    data.push(el);
                }
            });
            return data;
        },
        showBoletosLote() {},
    },
};
</script>

<style scoped>
.btn-search {
    margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/boleto/antigos.vue